import { WebAuth } from 'auth0-js';
import { auth0 as config } from '../../config';

const auth0 = new WebAuth(config);

export default auth0;
